import { Flex, Box, Icon } from "@chakra-ui/react";
import { FC } from "react";

import { InfoIcon, StarIcon, WarningIcon, SparkleIcon } from "ui/icons";

type MessageProps = {
  variant?: "info" | "tip" | "warning" | "sample";
};

const variants = {
  info: {
    borderColor: "gray.200",
    bg: "base.lightBackground",
    color: "text.secondary",
  },
  tip: {
    borderColor: "teal.200",
    bg: "teal.background",
    color: "teal.text",
  },
  warning: {
    borderColor: "warning.200",
    bg: "warning.background",
    color: "warning.text",
  },
  sample: {
    borderColor: "gray.200",
    bg: "base.lightBackground",
    color: "text.secondary",
  },
};

const icons = {
  info: <InfoIcon mr={3} boxSize={6} flexShrink={0} color="text.secondary" />,
  warning: (
    <WarningIcon mr={3} boxSize={6} flexShrink={0} color="warning.base" />
  ),
  tip: <StarIcon mr={3} boxSize={6} flexShrink={0} color="teal.base" />,
  sample: (
    <SparkleIcon mr={3} boxSize={6} flexShrink={0} color="teal.base" />
  ),
};

export const Alert: FC<Readonly<MessageProps>> = ({
  children,
  variant = "info",
}) => {
  const icon = icons[variant];

  return (
    <Flex
      border="1px"
      borderRadius="xl"
      padding={5}
      my={12}
      fontSize="lg"
      alignItems="start"
      sx={{ a: { color: "var(--theme-colors-link-hover)" } }}
      {...variants[variant]}
    >
      {icon}
      <Box sx={{ p: { margin: 0 } }}>{children}</Box>
    </Flex>
  );
};

export const Tip = (props) => <Alert variant="tip" {...props} />;

export const Info = (props) => <Alert variant="info" {...props} />;

export const Warning = (props) => <Alert variant="warning" {...props} />;
